import i18n from "@/i18n/i18n";

export default {
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  data() {
    return {
      confirmationOkTitle: null,
    };
  },
  computed: {
    _confirmationOkTitle() {
      return (
        this.confirmationOkTitle ||
        i18n.t("dashboard.confirmation.noKeepGrading")
      );
    },
  },
  methods: {
    showConfirmationLeaveModal({ title, text, okTitle }) {
      const modal = this.$showConfirmationLeaveModal({
        title: title || i18n.t("dashboard.confirmation.leaveTitle"),
        text: text || i18n.t("dashboard.confirmation.leaveText"),
        okTitle: okTitle || this._confirmationOkTitle,
      });
      if (!modal?.then) {
        return true;
      }

      return modal
        .then((value) => {
          return value;
        })
        .catch((err) => {
          this.$showToastError(
            `Error occurred while confirmation: ${err.message}`
          );
        });
    },

    getIsDirty() {
      return false;
    },

    handleBeforeUnload(event) {
      const isDirty =
        this.forceIsDirty !== undefined ? this.forceIsDirty : this.getIsDirty();

      if (isDirty) {
        event.returnValue = i18n.t("dashboard.confirmation.leaveTitle");
      }
    },

    async handleRouteChange(next) {
      const isDirty =
        this.forceIsDirty !== undefined ? this.forceIsDirty : this.getIsDirty();

      if (!isDirty) {
        next();

        return;
      }

      const canLeave = await this.showConfirmationLeaveModal({});

      if (canLeave) {
        next();
      }
    },
  },

  async beforeRouteLeave(to, from, next) {
    await this.handleRouteChange(next);
  },

  async beforeRouteUpdate(to, from, next) {
    await this.handleRouteChange(next);
  },
};
